import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { default as axios, default as axiosPE } from 'api/axios'
import storage from 'redux-persist/lib/storage'

const sessionState = JSON.parse(sessionStorage.getItem('state'))
const stateVacio = {
  user: null,
  token: null,
  permisos: [],
  permitir_seleccionar_subempresa: false,
}
const initialState = sessionState || stateVacio

// Cargar permisos de sessionStorage si existen
if (sessionState && !sessionState.permisos) {
  initialState.permisos = JSON.parse(sessionStorage.getItem('permisos') || '[]')
}

export const userLogin = createAsyncThunk('/login', async (loginData, { rejectWithValue }) => {
  try {
    const response = await axios.post('/login', loginData, {
      headers: { 'Content-Type': 'application/json' },
    })
    return response.data
  } catch (err) {
    const mensajeError = { message: err.response?.data }
    return rejectWithValue(mensajeError)
  }
})
export const authToken = createAsyncThunk('/authtoken/', async (loginData) => {
  const response = await axios.post('/authtoken/', loginData, {
    headers: { 'Content-Type': 'application/json' },
  })
  return response.data
})

export const cambiarUsuario = createAsyncThunk('/cambiauser', async (user) => {
  const response = await axiosPE.get(`/usuario/cambiar/${user.id}/`)
  sessionStorage.setItem('nuevoToken', response.data.token)
  return {
    token: response.data.token,
    refresh: response.data.refresh,
    user,
  }
})

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload
      state.user = user
      state.token = accessToken
      sessionStorage.setItem('state', JSON.stringify(state))
    },
    setToken: (state, action) => {
      const { token } = action.payload
      state.token = token
      sessionStorage.setItem('state', JSON.stringify(state))
    },
    logOut: (state) => {
      // Evitar múltiples logouts simultáneos usando sessionStorage
      if (sessionStorage.getItem('isLoggingOut') === 'true') return
      sessionStorage.setItem('isLoggingOut', 'true')

      // Limpiar el estado de Redux
      state.user = null
      state.token = null
      state.refresh = null
      state.permisos = []
      state.permitir_seleccionar_subempresa = false

      // Limpiar storage
      localStorage.removeItem('persist:root')
      sessionStorage.removeItem('state')
      sessionStorage.removeItem('permisos')
      sessionStorage.removeItem('permisoSeleccionado')

      sessionStorage.removeItem('isLoggingOut')
      window.location.href = '/'
    },
  },
  extraReducers(builder) {
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        state.user = action.payload.user
        state.token = action.payload.token
        state.refresh = action.payload.refresh
        state.permitir_seleccionar_subempresa =
          action.payload.permitir_seleccionar_subempresa ?? false

        // Guardar permisos
        const permisos = action.payload.user?.permisos_disponibles || []
        state.permisos = permisos
        sessionStorage.setItem('permisos', JSON.stringify(permisos))

        // Establecer el primer permiso como predeterminado
        if (permisos.length > 0 && !sessionStorage.getItem('permisoSeleccionado')) {
          sessionStorage.setItem('permisoSeleccionado', permisos[0].orden.toString())
        }

        sessionStorage.setItem('state', JSON.stringify(state))
      })
      .addCase(authToken.fulfilled, (state, action) => {
        state.user = action.payload.user
        state.token = action.payload.token
        state.refresh = action.payload.refresh
        sessionStorage.setItem('state', JSON.stringify(state))
      })
      .addCase(cambiarUsuario.fulfilled, (state, action) => {
        storage.removeItem('persist:root')
        state.user = action.payload.user
        state.token = action.payload.token
        state.refresh = action.payload.refresh
        window.location.pathname = '/'
      })
  },
})

export const { setCredentials, setToken, logOut } = userSlice.actions
export const selectUsuario = (state) => state?.user?.user
export const selectToken = (state) => state.token

export default userSlice.reducer

export const selectCurrentUser = (state) => state.user.user
export const selectCurrentToken = (state) => state.user.token
export const selectPermisos = (state) => state.user?.permisos || []
export const selectPermisoActual = (state) => {
  const ordenSeleccionado = sessionStorage.getItem('permisoSeleccionado')
  if (!ordenSeleccionado) return null

  const permisos = state.user?.permisos || []
  return permisos.find((p) => p.orden.toString() === ordenSeleccionado) || permisos[0] || null
}

export const selectPermitirSeleccionarSubempresa = (state) =>
  state.user?.permitir_seleccionar_subempresa ?? false
